module.exports = __webpack_public_path__ + "static/media/hamburger-restaurant.95101cce.svg";